import { Settings } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import axios from 'axios'
import { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { JobInfoRecommend, JobRecommend } from '../../../models/JobRecommend'
import { Mentee, User } from '../../../models/User'
import { RootState, useAppSelector } from '../../../store'
import { axiosGet, axiosPost } from '../../Common/Axios'
import Job from '../../Common/Job'
import TextAreaBox from '../../Common/TextAreaBox'
import Popup from '../../Popup/Popup'
import SettingPopup from './SettingPopup'
import { useReactToPrint } from 'react-to-print'
import { Inventory } from '../../../models/Inventory'
import InventoryListViewStudent from '../../Common/InventoryListView'

type Props = {
  mentee: Mentee | null
  student: User | null
}

function Main(props: Props) {
  const [recommendJobs, setRecommendJobs] = useState<JobInfoRecommend[]>([])
  const [mentee, setMentee] = useState<Mentee | null>(null)
  const [student, setStudent] = useState<User | null>(null)
  const [openSetting, setOpenSetting] = useState(false)
  const [inventories, setInventories] = useState<Inventory[]>([])

  const me = useAppSelector((state: RootState) => state.user.me)

  const loadMentee = async () => {
    const payload = {
      mentorUserId: me.id,
      menteeUserId: props.student?.id || 0,
    }
    const data = await axiosPost('/api/mentor/get_recommend_job', payload)

    console.log('get_recommend_job', data, 'payload', payload)
    setRecommendJobs(data)
  }

  const loadInventories = async () => {
    console.log('props.student', props.student)
    if (!props.student) {
      return
    }
    const data = await axiosGet(
      `/api/inventory/get_inventories/${props.student.id}`
    )
    console.log('get_inventories', data)
    setInventories(data)
  }

  useEffect(() => {
    setStudent(props.student)

    if (!props.student) {
      return
    }
    loadMentee()
    loadInventories()
  }, [props.student])

  // delete
  useEffect(() => {
    setMentee(props.mentee)

    if (props.mentee !== undefined && props.mentee !== null) {
      loadMentee()
    }
  }, [props.mentee])

  const updateMenteeInfo = async (menteeInfo: string) => {
    const payload = {
      mentorUserId: me.id,
      menteeUserId: props.mentee?.mentee.id,
      menteeInfo,
    }
    await axiosPost('/api/mentor/update_mentee_info', payload)
  }

  // 추천이유 적용 클릭시 [selector 변경]
  const applyRecommend = async (
    jobInfoRecommend: JobInfoRecommend,
    value: string
  ) => {
    if (mentee === null) {
      return
    }

    const payload: JobRecommend = {
      id: 0,
      jobId: jobInfoRecommend.job.id,
      isFromMentor: true,
      sendUserId: me.id,
      recvUserId: jobInfoRecommend.recvUserId,
      recommendContent: value,
    }

    await axiosPost('/api/mentor/update_recommend', payload)
  }

  return (
    <Container>
      <SettingIcon>
        <IconButton onClick={() => setOpenSetting(true)}>
          <Settings />
        </IconButton>
      </SettingIcon>
      <Popup open={openSetting} setOpen={setOpenSetting}>
        <SettingPopup setOpen={setOpenSetting} />
      </Popup>

      {student && (
        <>
          <UserInfo>
            <div>{student.username}</div>
            <div>{student.email}</div>
            <div>메모</div>
            <div>
              <TextAreaBox
                updateId={student.id}
                value={student.groupName}
                placeholder="멘티에 대해 메모해주세요"
                updateValue={updateMenteeInfo}
                isShowButtons={true}
              />
            </div>
          </UserInfo>
        </>
      )}
      <ListTitle>멘토가 추천한 직업</ListTitle>
      <Jobs>
        {recommendJobs &&
          recommendJobs.map(
            (jobInfoRecommend: JobInfoRecommend, index: number) => {
              const { job } = jobInfoRecommend
              return (
                <JobItem key={index}>
                  <Job
                    id={job.id}
                    image={job.photo}
                    name={job.name}
                    description={job.overview}
                  />
                  <TextAreaBox
                    updateId={jobInfoRecommend.id}
                    value={jobInfoRecommend.recommendContent}
                    placeholder="추천하는 이유를 알려주세요."
                    updateValue={(value: string) =>
                      applyRecommend(jobInfoRecommend, value)
                    }
                    isShowButtons={true}
                  />
                </JobItem>
              )
            }
          )}
      </Jobs>
      <ListTitle>직업인벤토리</ListTitle>
      <InventoryListViewStudent inventories={inventories} me={student} />
    </Container>
  )
}

const Container = styled.div`
  grid-area: main;
  margin-bottom: 1rem;
  position: relative;
`
const SettingIcon = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;

  & > svg:hover {
    color: gray;
  }
`
const JobItem = styled.div`
  padding-bottom: 10px;
  padding-left: 10px;
`

const UserInfo = styled.div`
  padding-top: 10px;
  color: #333;

  & > div:nth-child(1) {
    font-size: 1.3rem;
    font-weight: 600;
    padding-bottom: 10px;
  }
  div:nth-child(2) {
    color: #888;
    font-size: 1rem;
    padding-bottom: 20px;
  }
  div:nth-child(3) {
    color: #888;
    font-size: 1.1rem;
    padding-bottom: 5px;
    font-weight: 600;
  }
  div:nth-child(4) {
    padding-left: 10px;
  }
`
const ListTitle = styled.div`
  padding: 20px 0 10px;
  color: #888;
  font-size: 1.1rem;
  font-weight: 600;
`
const Jobs = styled.div`
  & > div:nth-child(2n) {
    margin-bottom: 30px;
  }
  & > div:nth-child(2n + 1) {
    margin-bottom: 10px;
  }
`

export default Main
